import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Batch, QueryParamsBatch } from '@batch/shared/models/batch';
import { environment } from '@environments/environment';
import { RsFormatFile } from '@rs-shared-lib/models/rs-format-file';
import { RsFormatPaginatedListRequestBody, UUID } from '@rs-shared-lib/models';
import { rsFormatPaginatedListRequestBody } from '@rs-shared-lib/utils/custom-rxjs-operators/rsFormatPaginatedListRequestBody';
import { rsFormatFile } from '@rs-shared-lib/utils/custom-rxjs-operators/rsFormatFile';

@Injectable({
  providedIn: 'root'
})
export class BatchService {

  private readonly http = inject(HttpClient);

  public readonly getBatches = (params: QueryParamsBatch): Observable<RsFormatPaginatedListRequestBody<Batch[]>> => {
    return this.http.get<Batch[]>(
      `${environment.apiUrl}/v2/file-process-execution`,
      { observe: 'response', params: { ...params } }
    )
      .pipe(rsFormatPaginatedListRequestBody());
  }

  public readonly processBatch = (formData: FormData): Observable<UUID> => {
    return this.http.post<UUID>(
      `${environment.apiUrl}/v2/file-process-execution`,
      formData
    );
  }

  public readonly downloadBatchInputFile = (batchId: UUID): Observable<RsFormatFile> => {
    return this.http.get<HttpResponse<Blob>>(
      `${environment.apiUrl}/v2/file-process-execution/${batchId}/input-file`,
      {
        observe: 'response' as 'body',
        responseType: 'blob' as 'json'
      }
    ).pipe(rsFormatFile());
  }

  public readonly downloadBatchResultFile = (batchId: UUID): Observable<RsFormatFile> => {
    return this.http.get<HttpResponse<Blob>>(
      `${environment.apiUrl}/v2/file-process-execution/${batchId}/result-file`,
      {
        observe: 'response' as 'body',
        responseType: 'blob' as 'json'
      }
    ).pipe(rsFormatFile());
  }

  public readonly cancelBatch = (batchId: UUID): Observable<void> => {
    return this.http.delete<void>(
      `${environment.apiUrl}/v2/file-process-execution/${batchId}`
    );
  }

}
